import React from 'react';
import BaseCard, { EcmBaseCardProps } from './BaseCard';
import styles from './../CardsList.module.less';

export type EcmIconCardProps = EcmBaseCardProps & {
  icon?: string;
};

type IconCardProps = {
  ecmContent: EcmIconCardProps;
};

const IconCard: React.FC<IconCardProps> = ({ ecmContent }) => {
  const { icon, title } = ecmContent;

  return (
    <div>
      {icon && <img src={icon} alt={title} className={styles.card_icon} />}
      <BaseCard ecmContent={ecmContent} />
    </div>
  );
};

export default IconCard;
